import { Center, Spinner } from "@chakra-ui/react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

const ProtectedRoute = ({ children }: { children: JSX.Element }) => {
  const { isAuthenticated, isBootstrapping, appUserProfile } = useAuth();
  const location = useLocation();

  const userStatus = appUserProfile?.status;

  if (isBootstrapping) {
    return (
      <Center minH="100vh">
        <Spinner size="lg" />
      </Center>
    );
  }

  if (!isAuthenticated) {
    return (
      <Navigate
        to="/login"
        replace
        state={{ from: location.pathname + location.search + location.hash }}
      />
    );
  }

  if (
    userStatus === "awaiting_validation" ||
    userStatus === "pending_validation"
  ) {
    return <Navigate to="/authentication-pending" replace />;
  }

  if (userStatus === "blocked") {
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default ProtectedRoute;
